import template from './search.html';
import controller from './search.controller';
import './search.styl';

const searchComponent = {
  template,
  controller,
  controllerAs  : 'search',
  bindings      : {
    fields: '<'
  }
};

export default searchComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/search/search.component.js
 **/